import axios from "axios";
import { generalActions } from "../store/actions";
import store from "../store";
import { handleLogout } from "../store/services/service";
import {
  ensureFreshToken,
  getStoredAccessToken,
  getStoredRefreshToken,
  refreshAccessToken,
} from "./tokenManager";
import { handleRateLimitError } from "./rateLimitHandler";

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    accept: "application/json",
    "content-type": "application/json",
  },
});

apiInstance.interceptors.response.use(
  (response) => {
    // Safety net alongside the proactive scheduler in tokenManager: if the
    // token is close to expiring, kick off a (deduped) background refresh.
    ensureFreshToken().catch(() => {});
    return response;
  },

  async (error) => {
    handleRateLimitError(error);

    const status = error?.response?.status;
    const originalRequest = error?.config;

    if (
      (status === 401 || status === 403) &&
      originalRequest &&
      !originalRequest._retry &&
      getStoredRefreshToken()
    ) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers = {
          ...originalRequest.headers,
          Authorization: `Bearer ${newAccessToken}`,
        };
        return apiInstance(originalRequest);
      } catch (refreshError) {
        store.dispatch(
          generalActions.showToast({
            title: "Your session has expired. Please login again.",
            type: "error",
          })
        );
        handleLogout();
        return Promise.reject(error);
      }
    }

    if ((status === 401 || status === 403) && !getStoredAccessToken()) {
      handleLogout();
    }

    return Promise.reject(error);
  }
);

export const routes = {
  getResourceMonitering: "/Resources/Monitor",
  getShiftsList: "/Shifts",
  getTasks: "/Resources/:resourceId/Monitor",
  getContribution: "/Resources/:resourceId/Contribution",
  timeOff: "/Leaves",
  timeline: "/Projects/:id/TimeLine",
  bascelineability: "/Projects/:id/Baselines",
  createBaseline: "/Projects/:id/Baselines",
  markTaskCompleted: "Tasks/:id/Status",
  taskDependencies: "Tasks/:id/Dependencies",
  taskDates: "Tasks/:id/Dates",
  getTaskById: "/Tasks/:id",
  getProgramTimeline: "/Programs/:id/TimeLine",
  getProjectTimeline: "/Projects/:id/SummaryTimeLine",
  getProjectOwnTimeline: "/Projects/:id/TimeLine",
  getPortfolioTimeline: "/Portfolios/:id/timeline",
};
